export default {
    HANDLE_EMAIL_EVALUATION_TOPIC: "handleEmailEvaluation",
    ACTIVATED_EVALUATION: "activatedEvaluation",
    USER_IMAGES_AVAILABLE: "userImagesAvailable",
};
